export class UpdateSocialLinksModel {
  MembershipId: string;
  FacebookUrl: string;
  InstagramUrl: string;
  TwitterUrl: string;
  YoutubeUrl: string;
  PintrestUrl: string;
}
